import React from 'react';
import { string, shape } from 'prop-types';

import { makeParagraph } from 'utils';

const NewsCard = ({
    url,
    title,
    target,
    image,
    date,
    dateTitle,
    buttonTitle,
    category,
    perex
}) => (
    <article className="c-news-card">
        <div className="c-news-card__image">
            {!!image && !!image.url && (
                <img
                    loading="lazy"
                    src={image.url}
                    alt={image.alt}
                />
            )}
        </div>
        <div className="c-news-card__body">
            {(date || category) && (
                <div className="c-news-card__caption">
                    {date && (
                        <span>
                            {dateTitle} {date}
                        </span>
                    )}
                    {category && (
                        <span className="c-news-card__category">
                            {category}
                        </span>
                    )}
                </div>
            )}
            {title && <h3 className="c-news-card__title">{title}</h3>}
            {perex && (
                <div
                    className="c-news-card__perex"
                    dangerouslySetInnerHTML={{
                        __html: makeParagraph(perex)
                    }}
                />
            )}
        </div>
        <div className="c-news-card__footer">
            <a
                href={url}
                className="c-news-card__link"
                target={target || undefined}
            >
                <span className="link">{buttonTitle}</span>
            </a>
        </div>
    </article>
);

NewsCard.propTypes = {
    url: string.isRequired,
    title: string.isRequired,
    target: string,
    image: shape({ url: string, alt: string }).isRequired,
    date: string.isRequired,
    dateTitle: string.isRequired,
    buttonTitle: string.isRequired,
    category: string,
    perex: string
};

export default NewsCard;
